import React, { Component } from "react";
import Header from "../component/Header";
import Breadcrumb from "../component/Breadcumb";
import Footer from "../component/Footer";

import location from "../assets/img/icon/location.png"
import phone from "../assets/img/icon/phone.png"
import email from "../assets/img/icon/email.png"
import { Col, Modal, ModalBody, Row } from "reactstrap";
import { FaCheckCircle } from "react-icons/fa";
import { BASEURL } from "../../Global";

class ContactUs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            subject: '',
            message: '',
            mobile: '',
            isModal: false,
            themeSetting:[],
        };
    }

    componentDidMount() {
        document.title = "Contact US - My Jainism";
        this.fetchThemeSetting();
    }
    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({
            [name]: value
        });
    };

    handleSubmit = async (event) => {
        event.preventDefault();
        const { name, email, subject, message, mobile } = this.state;
        // Validate email format
        const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
        if (!emailPattern.test(email)) {
            alert("Please enter a valid email address.");
            return;
        }

        // Validate mobile number
        if (!/^\d{10}$/.test(mobile)) {
            alert("Mobile number must be exactly 10 digits.");
            return;
        }

        const formData = {
            name,
            email,
            subject,
            message,
            mobile,
        };
        try {
            await fetch(`${BASEURL}/createcontactus`,
                {
                    method: 'POST',
                    headers: {
                        // Authorization: 'Bearer ' + Data.access_token,
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    }, body: JSON.stringify(formData)
                })
                .then((response) => {
                    if (response.status === 200) {
                        response.json().then((responseJson) => {
                            if (responseJson.data) {
                                // toastr.success(`${responseJson.message}`)
                                // this.setState({ isModal: true })
                                this.setState({
                                    name: '',
                                    email: '',
                                    subject: '',
                                    message: '',
                                    mobile: '',
                                    isModal: true,
                                })
                            } else {
                                // toastr.warning(`${responseJson.message}`)
                            }
                        });

                    } else {
                        // toastr.warning("Something Went Wrong !!")
                    }
                })
                .catch((error) => {
                    console.log("Fetch Error", error);
                });
        } catch (error) {
            console.log('Try Error', error);
        }
    };
async fetchThemeSetting() {
        try {
            await fetch(`${BASEURL}/themesettingswithoutauth`, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                }
            })
                .then(response => {
                    if (response.status === 200) {
                        response.json().then(responseJson => {
                            if (responseJson.data) {
                                this.setState({ themeSetting: responseJson.data[0] })
                            } else {
                                // console.log("Data Not Found !!")
                            }
                        })
                    } else {
                        // console.log("Something Went Wrong !!")
                    }
                })
                .catch((error) => console.error(error));
        } catch (e) {
            console.log("ERROR", e)
        }
    }
    render() {
        return (
            <React.Fragment>
                <Header />
                <Breadcrumb title={"Contact Us"} />
                <section className="contact-section space-page">
                    <div className="container">
                        <div className="row gx-50 gy-30">
                            <div className="col-lg-5 wow fadeInLeft" data-wow-delay="0.1s">
                                <div className="contact-form-box">
                                    <h2 className="contact-title">Contact Us</h2>
                                    {/* <p className="mb-35">Lorem ipsum dolor sit amet, consectetur adipis do eiusmod tempor indunt ut labore et dolore magna aliqua.</p> */}
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="row">
                                            <div className="form-group col-12 mt-5">
                                                <label for="name" className="form-label">Your Name*</label>
                                                <input type="text" name="name" className="form-control" id="name" placeholder="Your name..."
                                                    value={this.state.name}
                                                    onChange={this.handleChange}
                                                    required />
                                            </div>
                                            <div className="form-group col-12">
                                                <label for="email" className="form-label">Your Email*</label>
                                                <input type="email" name="email" className="form-control" id="email" placeholder="info@example.com"
                                                    value={this.state.email}
                                                    onChange={this.handleChange}
                                                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                                                    required />
                                            </div>
                                            <div className="form-group col-12">
                                                <label for="mobile" className="form-label">Your Mobile*</label>
                                                <input type="number" name="mobile" className="form-control" id="mobile" placeholder="Your Mobile..."
                                                    value={this.state.mobile}
                                                    onChange={this.handleChange}
                                                    minLength={10}
                                                    maxLength={10}
                                                    pattern="\d{10}"
                                                    required />
                                            </div>
                                            <div className="form-group col-12">
                                                <label for="subject" className="form-label">Subject*</label>
                                                <input type="text" name="subject" className="form-control" id="sub" placeholder="Subject"
                                                    value={this.state.subject}
                                                    onChange={this.handleChange}
                                                    required />
                                            </div>
                                            <div className="form-group col-12">
                                                <label for="message" className="form-label">Your Message*</label>
                                                <textarea className="form-control" name="message" id="message" placeholder="Describe Your Opinion"
                                                    value={this.state.message}
                                                    onChange={this.handleChange}
                                                    required></textarea>
                                            </div>
                                            <div className="form-group col-12 mt-5">
                                                <button type="submit" className="vs-btn wave-btn">Send Now</button>
                                            </div>
                                        </div>
                                        <p className="form-messages mb-0 mt-3"></p>
                                    </form>
                                </div>
                            </div>
                            <div className="col-lg-7 wow fadeInRight" data-wow-delay="0.1s">
                                <div className="contact-info-box">
                                    <h2 className="contact-title">Our Information</h2>
                                    <div className="info-media">
                                        <div className="media-icon">
                                            <img src={location} alt="icon" />
                                        </div>
                                        <div className="media-body">
                                            <h4 className="info-title">Office Address:</h4>
                                            <p className="info-text">{this.state.themeSetting?.address}</p>
                                        </div>
                                    </div>
                                    <div className="info-media">
                                        <div className="media-icon">
                                            <img src={phone} alt="icon" />
                                        </div>
                                        <div className="media-body">
                                            <h4 className="info-title">Call Us For Help:</h4>
                                            <p className="info-text"><a href={`tel:${this.state.themeSetting?.mobile}`}>{this.state.themeSetting?.mobile}</a></p>
                                        </div>
                                        
                                    </div>
                                    <div className="info-media">
                                        <div className="media-icon">
                                            <img src={phone} alt="icon" />
                                        </div>
                                        <div className="media-body">
                                            <h4 className="info-title">Whatsapp Us For Help:</h4>
                                            <p className="info-text"><a href={`https://wa.me/+91${this.state.themeSetting?.whatsapp_no}`} target="_blank">{this.state.themeSetting?.whatsapp_no}</a></p>
                                            {/* <a href={`https://wa.me/${this.state.themeSetting?.whatsapp_no}`} target="_blank">Click here</a> */}
                                        </div>
                                    </div>
                                    <div className="info-media">
                                        <div className="media-icon">
                                            <img src={email} alt="icon" />
                                        </div>
                                        <div className="media-body">
                                            <h4 className="info-title">Mail info:</h4>
                                            <p className="info-text"><a href={`mailto:${this.state.themeSetting?.email}`}> {this.state.themeSetting?.email}</a></p>
                                        </div>
                                    </div>
                                    <div className="contact-location">
                                        <iframe src="https://maps.google.com/maps?width=100%25&amp;height=200&amp;hl=en&amp;q=Chikhodara+(My%20Business%20Name)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed" allowfullscreen="" loading="lazy"></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {
                    this.state.isModal && (
                        <Modal isOpen={this.state.isModal} centered={true} toggle={() => this.setState({ isModal: false })}>
                            <ModalBody className="py-3 px-5">
                                <Row>
                                    <Col lg={12}>
                                        <div className="text-center">
                                            <i
                                                className="mdi mdi-alert-circle-outline"
                                                style={{ fontSize: "9em", color: "orange" }}
                                            />
                                            <FaCheckCircle
                                                style={{
                                                    fontSize: "9em", color: "#22bb33"
                                                }} />
                                            <h2>Thank you for contact us</h2>
                                            <h4>We will contact you shortly</h4>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="text-center mt-3">
                                            <button
                                                type="button"
                                                className="btn btn-lg me-2"
                                                style={{ background: "#22bb33", color: "#fff" }}
                                                onClick={() => this.setState({ isModal: false })}
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </ModalBody>
                        </Modal>
                    )
                }
                <Footer />
            </React.Fragment>
        );
    }
}

export default ContactUs;
